import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Button, ButtonIcon } from '@/components/ui/button';
import { AvatarWrapper } from '@/components/ui/avatar';
import { CardProgressWrapper } from '@/components/ui/card';
import { ChallengeBanner, ChallengeBannerHeader, ChallengeBannerBody, ChallengeBannerFooter, ChallengeBannerTitle, ChallengeBannerDate, ChallengeBannerCount } from '@/components/custom/challenge/challenge-banner';
import {
  ChallengeCard,
  ChallengeCardHat,
  ChallengeCardBody,
  ChallengeCardText,
  ChallengeCardTitle,
  ChallengeCardName,
  ChallengeCardCategory,
  ChallengeCardIcon,
  ChallengeCardBanner,
  ChallengeCardBannerText,
  ChallengeCardFooter
} from '@/components/custom/challenge/challenge-card';
import { SpinWheelWrapper, SpinWheelWrapperCount, SpinWheel, SpinWheelRoulette, SpinWheelSlice, SpinWheelSliceText } from '@/components/custom/spin-wheel/spin-wheel';
import {
  Certificate,
  CertificateHeader,
  CertificateHeaderContent,
  CertificateTitle,
  CertificateIcon,
  CertificateBody,
  CertificateText,
  CertificateKpis,
  CertificateKpi,
  CertificateKpiContent,
  CertificateKpiValue,
  CertificateKpiLabel,
  CertificateFooter
} from '@/components/custom/certificate/certificate';
import {
  ChallengeQuestion,
  ChallengeQuestionCount,
  ChallengeQuestionHeader,
  ChallengeQuestionTitle,
  ChallengeQuestionBody,
  ChallengeQuestionList,
  ChallengeQuestionRadio,
  ChallengeQuestionAlternative,
  ChallengeQuestionFooter,
  ChallengeQuestionComment,
  ChallengeQuestionCommentContent
} from '@/components/custom/challenge/challenge-question';
import { ChallengeCountdown, ChallengeCountdownContent, ChallengeCountdownHeader, ChallengeCountdownHat, ChallengeCountdownTitle, ChallengeCountdownBody, ChallengeCountdownText } from '@/components/custom/challenge/challenge-countdown';
import { FiAward, FiBookOpen, FiClock, FiInfo, FiTarget } from 'react-icons/fi';
import { VscGame } from 'react-icons/vsc';

const SLICES = [
  { name: 'Matematica', color: '#7B63BF' },
  { name: 'Portugues', color: '#F99153' },
  { name: 'Ciencias', color: '#32C9D3' },
  { name: 'Historia', color: '#FF4C6F' }
];

export function GamificationSection() {
  return (
    <ShowcaseSection
      id="gamification"
      title="Gamification"
      description="Desafios, roleta de premios, certificado e elementos de jogo"
    >
      <ShowcaseItem
        label="ChallengeBanner — default"
        description="Banner gradiente para tela de desafio com progresso e contador"
      >
        <ChallengeBanner>
          <ChallengeBannerHeader>
            <ChallengeBannerTitle>Desafio da Semana</ChallengeBannerTitle>
            <ChallengeBannerDate>De 12/04/2026 a 19/04/2026</ChallengeBannerDate>
          </ChallengeBannerHeader>
          <ChallengeBannerBody>
            <CardProgressWrapper
              variant="cover"
              percentage={62}
              toFixed={0}
            />
          </ChallengeBannerBody>
          <ChallengeBannerFooter>
            <ChallengeBannerCount>
              <FiInfo /> Restam 5 dias
            </ChallengeBannerCount>
          </ChallengeBannerFooter>
        </ChallengeBanner>
      </ShowcaseItem>

      <ShowcaseItem
        label="ChallengeBanner — admin"
        description="Variante admin (fundo claro)"
      >
        <ChallengeBanner variant="admin">
          <ChallengeBannerHeader>
            <ChallengeBannerDate>Criado em 10 de Abril</ChallengeBannerDate>
            <ChallengeBannerTitle>Painel de Desafios</ChallengeBannerTitle>
          </ChallengeBannerHeader>
        </ChallengeBanner>
      </ShowcaseItem>

      <ShowcaseItem
        label="ChallengeCard"
        description="Cartao com hat, avatar, body, banner de pontos e footer (default + turbo variant)"
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <ChallengeCard>
            <ChallengeCardHat>Matematica</ChallengeCardHat>
            <AvatarWrapper
              size="lg"
              name="Prof. Ana Silva"
              className="mx-auto"
            />
            <ChallengeCardBody>
              <ChallengeCardCategory>
                <ChallengeCardIcon square>
                  <VscGame />
                </ChallengeCardIcon>
                Quiz
              </ChallengeCardCategory>
              <ChallengeCardText>
                <ChallengeCardTitle>Quiz de Algebra</ChallengeCardTitle>
                <ChallengeCardName>Prof. Ana Silva</ChallengeCardName>
                <p className="m-0 truncate">10 questoes · 15 min</p>
              </ChallengeCardText>
              <ChallengeCardBanner>
                <ChallengeCardBannerText>Ganhe 50 Pontos</ChallengeCardBannerText>
              </ChallengeCardBanner>
            </ChallengeCardBody>
            <ChallengeCardFooter>
              <Button
                variant="primary-light"
                size="sm"
                border
                fullWidth
              >
                <ButtonIcon>
                  <VscGame />
                </ButtonIcon>{' '}
                Comecar desafio
              </Button>
            </ChallengeCardFooter>
          </ChallengeCard>

          <ChallengeCard variant="turbo">
            <ChallengeCardHat>Novidade</ChallengeCardHat>
            <div className="relative my-8 flex items-end justify-center -space-x-6">
              <AvatarWrapper
                name="Aluno 1"
                className="size-14"
              />
              <AvatarWrapper
                name="Aluno 2"
                className="size-20"
              />
              <AvatarWrapper
                name="Aluno 3"
                className="size-14"
              />
            </div>
            <ChallengeCardBody className="justify-start">
              <ChallengeCardTitle>Desafie seus colegas</ChallengeCardTitle>
              <p className="m-0 text-xs text-neutral-dark">Participe de duelos e teste seus conhecimentos</p>
            </ChallengeCardBody>
            <ChallengeCardFooter>
              <Button
                variant="merit"
                size="sm"
                border
                fullWidth
              >
                Iniciar Duelos
              </Button>
            </ChallengeCardFooter>
          </ChallengeCard>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="ChallengeQuestion"
        description="Tela de questao com header + lista de alternativas (variantes success/danger)"
      >
        <ChallengeQuestion>
          <ChallengeQuestionCount>
            <VscGame /> 1 / 10
          </ChallengeQuestionCount>
          <ChallengeQuestionHeader>
            <ChallengeQuestionTitle>Qual o resultado de 7 x 8?</ChallengeQuestionTitle>
          </ChallengeQuestionHeader>
          <ChallengeQuestionBody>
            <ChallengeQuestionList>
              <ChallengeQuestionAlternative>
                <ChallengeQuestionRadio /> 54
              </ChallengeQuestionAlternative>
              <ChallengeQuestionAlternative variant="success">
                <ChallengeQuestionRadio /> 56
              </ChallengeQuestionAlternative>
              <ChallengeQuestionAlternative variant="danger">
                <ChallengeQuestionRadio /> 58
              </ChallengeQuestionAlternative>
              <ChallengeQuestionAlternative>
                <ChallengeQuestionRadio /> 64
              </ChallengeQuestionAlternative>
            </ChallengeQuestionList>
          </ChallengeQuestionBody>
          <ChallengeQuestionFooter>
            <ChallengeQuestionComment>
              <ChallengeQuestionCommentContent>
                <p>
                  <strong>Comentarios do seu professor:</strong> 7×8=56. Lembre-se da tabuada do 7 e 8.
                </p>
              </ChallengeQuestionCommentContent>
            </ChallengeQuestionComment>
            <Button
              wide
              className="mt-3"
            >
              Proxima questao
            </Button>
          </ChallengeQuestionFooter>
        </ChallengeQuestion>
      </ShowcaseItem>

      <ShowcaseItem
        label="ChallengeCountdown"
        description="Contagem regressiva antes da questao (overlay sobre tela)"
        previewClassName="relative !p-0 !min-h-[480px] overflow-hidden"
      >
        <ChallengeCountdown>
          <AvatarWrapper
            name="Prof. Ana"
            size="md"
          />
          <ChallengeCountdownContent>
            <ChallengeCountdownHeader>
              <ChallengeCountdownHat>Tema escolhido:</ChallengeCountdownHat>
              <ChallengeCountdownTitle>Matematica Basica</ChallengeCountdownTitle>
            </ChallengeCountdownHeader>
            <ChallengeCountdownBody>
              <ChallengeCountdownText>Prepare-se!</ChallengeCountdownText>
              <Button variant="outline">
                <ButtonIcon>
                  <FiClock />
                </ButtonIcon>{' '}
                00:05
              </Button>
            </ChallengeCountdownBody>
          </ChallengeCountdownContent>
        </ChallengeCountdown>
      </ShowcaseItem>

      <ShowcaseItem
        label="SpinWheel"
        description="Roleta de premios com 4 fatias (cores das materias)"
      >
        <SpinWheelWrapper>
          <SpinWheelWrapperCount>Rodada 1</SpinWheelWrapperCount>
          <SpinWheel>
            <SpinWheelRoulette
              slices={SLICES.length}
              rotate={0}
            >
              {SLICES.map((slice, idx) => {
                const rotateValue = (360 / SLICES.length) * idx;
                return (
                  <SpinWheelSlice
                    key={slice.name}
                    bg={slice.color}
                    rotate={rotateValue}
                    slices={SLICES.length}
                  >
                    <SpinWheelSliceText>{slice.name}</SpinWheelSliceText>
                  </SpinWheelSlice>
                );
              })}
            </SpinWheelRoulette>
          </SpinWheel>
        </SpinWheelWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="Certificate"
        description="Diploma de conclusao com KPIs"
      >
        <Certificate>
          <CertificateHeader>
            <CertificateHeaderContent>
              <CertificateIcon>
                <FiAward />
              </CertificateIcon>
              <CertificateTitle>Certificado de Conclusao</CertificateTitle>
            </CertificateHeaderContent>
          </CertificateHeader>
          <CertificateBody>
            <CertificateText>
              Certificamos que <strong>Bruno Santos</strong> concluiu o curso <strong>Matematica para o ENEM</strong> com aproveitamento de <strong>92%</strong>. <br />
              <small>Emitido em 15 de Abril de 2026.</small>
            </CertificateText>
            <CertificateKpis>
              <CertificateKpi>
                <CertificateKpiContent>
                  <FiClock
                    size={20}
                    className="text-primary"
                  />
                  <CertificateKpiValue>120h</CertificateKpiValue>
                </CertificateKpiContent>
                <CertificateKpiLabel>Carga horaria</CertificateKpiLabel>
              </CertificateKpi>
              <CertificateKpi>
                <CertificateKpiContent>
                  <FiBookOpen
                    size={20}
                    className="text-primary"
                  />
                  <CertificateKpiValue>48</CertificateKpiValue>
                </CertificateKpiContent>
                <CertificateKpiLabel>Aulas concluidas</CertificateKpiLabel>
              </CertificateKpi>
              <CertificateKpi>
                <CertificateKpiContent>
                  <FiTarget
                    size={20}
                    className="text-primary"
                  />
                  <CertificateKpiValue>92%</CertificateKpiValue>
                </CertificateKpiContent>
                <CertificateKpiLabel>Aproveitamento</CertificateKpiLabel>
              </CertificateKpi>
            </CertificateKpis>
          </CertificateBody>
          <CertificateFooter>
            <Button variant="outline">Baixar PDF</Button>
          </CertificateFooter>
        </Certificate>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
